




































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import axios from "axios";
import {SERVER_HOST_QR} from "@/config";
import BtnDefault from "@/components/UI/BtnDefault.vue";
import TooltipSimple from "@/components/UI/TooltipSimple.vue";
import IQuestion from "@/components/icons/IQuestion.vue";

const newstatistics = namespace('newstatistics')


@Component({
  name: "DataTableScanProducts",
  components: {IQuestion, TooltipSimple, BtnDefault}
})
export default class DataTableScanProducts extends Vue {

  @Prop({type: Array, default: []}) items!: string[]
  @Prop({type: String, default: ''}) title!: string
  @Prop({ type: Boolean, default: false }) protected loading!: boolean

  dialog: boolean = false
  currentProduct: any = {}
  selectedTableItem: any = null
  currentProductLoading: boolean = false
  currentProductError: boolean = false
  normalizedItems: any[] = []

  openInterest(item:any){
    if (!item.value) return
    this.selectedTableItem = item
    this.dialog = true
    this.fetchProductData()
  }
  normalizeProductScans(tabItem: any)  {

    const countPhoneScans: number = tabItem.value - this.currentProduct.scannedBadges.length
    if (this.currentProduct.scannedBadges.length) {
      this.normalizedItems = this.currentProduct.scannedBadges.map((product: any) => {
        return {
          ...product,
          count: 1
        }
      })
    }
    for (let i = 0; i < countPhoneScans; i++) {
      this.normalizedItems.push({
        name: this.$t('newstatistics.v4.scannings.scan_with_camera'),
        phone: '-',
        email: '-',
        city: '-',
        position: '-',
        count: '-',
        companyTitle: '-'
      })
    }
  }

  closeDialog(){
    this.currentProduct = {}
    this.selectedTableItem = null
    this.normalizedItems = []
    this.dialog = false
  }
  async fetchProductData() {
    this.currentProductError = false
    this.currentProductLoading = true
    try {
      const { data } = await axios.get(`${SERVER_HOST_QR}statistic/company/product/${this.selectedTableItem.productId}/scanned-badges`)
      this.currentProduct = data.data
      this.normalizeProductScans(this.selectedTableItem)
    } catch (e) {
      this.currentProductError = true
    } finally {
      this.currentProductLoading = false
    }
  }
  get  headers(){
   return [
      {
        text: this.$t("newstatistics.visitor_badges_scanned.fio"),
        value: 'name'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.phone"),
        value: 'phone'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.e-mail"),
        value: 'email'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.city"),
        value: 'city'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.company"),
        value: 'companyTitle'
      },
      {
        text: this.$t("newstatistics.visitor_badges_scanned.position"),
        value: 'position'
      },
      {
        text: this.$t("newstatistics.interested_visitors.number_scans"),
        value: 'count'
      }
    ]
  }
}
